import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { DxUser } from '@digitaix/types';

export enum AuthProviders {
  Google,
}

@Injectable({ providedIn: 'root' })
export class AuthService<User = DxUser, Provider = AuthProviders> {
  public user: BehaviorSubject<User | null | false> = new BehaviorSubject(null);

  public signInWithEmailAndPassword(
    email: string,
    password: string,
  ): Observable<any> {
    return throwError(
      '[AuthService::signInWithEmailAndPassword] Not implemented',
    );
  }

  public signOut(): Observable<any> {
    return throwError('[AuthService::signOut] Not implemented');
  }

  public createUserWithEmailAndPassword(
    email: string,
    password: string,
  ): Observable<any> {
    return throwError(
      '[AuthService::createUserWithEmailAndPassword] Not implemented',
    );
  }

  public sendPasswordResetEmail(email: string): Observable<any> {
    return throwError('[AuthService::sendPasswordResetEmail] Not implemented');
  }

  public sendPasswordReset(password: string, token: string): Observable<any> {
    return throwError('[AuthService::sendPasswordReset] Not implemented');
  }

  public sendEmailVerification(): Observable<any> {
    return throwError('[AuthService::sendEmailVerification] Not implemented');
  }

  public signInWithProvider(provider: Provider): Observable<any> {
    return throwError('[AuthService::signInWithProvider] Not implemented');
  }

  public applyActionCode(oobCode: string): Observable<any> {
    return throwError('[AuthService::applyActionCode] Not implemented');
  }

  public createUser(email: string, password: string): Observable<any> {
    return throwError('[AuthService::createUser] Not implemented');
  }

  public reset(): void {}
}
